import axios from 'axios';
import useSWR from 'swr';
import { formatAndThrowApiError } from '@/helpers/api';

const useCompanyDomains = (companyUid) => {
  const url = `/admin/company-domain?companyUid=${companyUid}`;
  const swr = useSWR(url, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });

  return swr;
};

const usePostCompanyDomain = () => {
  const postCompanyDomain = async (payload) => {
    try {
      const url = `/admin/company-domain`;
      const result = await axios.post(url, payload);
      return result.data;
    } catch (error) {
      formatAndThrowApiError(error);
    }
  };
  return postCompanyDomain;
};
export { useCompanyDomains, usePostCompanyDomain };
